import validateFilename from '../generated/upload-filename.validator';

export const FILENAME_HELPER_TEXT = 'Max 128 characters; avoid \\ / : * ? " < > |.';

const messages = {
  required: 'Filename is required.',
  maxLength: max => `Filename is too long (maximum ${max} characters).`,
  forbiddenChars: 'Filename cannot contain \\ / : * ? " < > |.',
  dotDot: "Filename cannot contain '..'.",
  leadingTrailing: 'Filename cannot start or end with a space or dot.',
};

function formatError(errors) {
  const e = errors[0];
  if (e.keyword === 'maxLength') return messages.maxLength(e.params.limit);
  if (e.keyword === 'minLength' || e.keyword === 'type') return messages.required;
  if (e.keyword === 'pattern') return messages.leadingTrailing;
  if (e.keyword === 'not') {
    return e.parentSchema?.pattern === '\\.\\.' ? messages.dotDot : messages.forbiddenChars;
  }
  return messages.required;
}

export function validateUploadFilename(name) {
  if (validateFilename(name)) return { valid: true, message: null };
  return { valid: false, message: formatError(validateFilename.errors) };
}
